import ConceptBase from '../concept_base';

class Naming extends ConceptBase {
  constructor(projectData, priceData, size) {
    super(projectData, priceData, size);
  }
}

export default Naming;
